import React from "react";
import {
  Footers,
  Container,
  Logo,
  Text,
  Copyright,
  Combo,
  Icons,
  Icon,
} from "./style";
import facebookicon from "resources/facebook.png";
import blogicon from "resources/blog.png";
import kakaoicon from "resources/kakao.png";

const Footer = () => {
  const selectChange = (event) => {
    switch (event.target.value) {
      case "hanyang":
        window.open("https://www.hanyang.co.kr/");
        break;
      case "gothic":
        window.open("https://www.hanyang.co.kr/hygothic/");
        break;
      case "fontbada":
        window.open("https://www.fontbada.co.kr");
        break;
      default:
        break;
    }
  };

  const goToSNS = (event) => window.open(event.target.id);
  return (
    <Footers className="no-print">
      <Container>
        <Logo />
        <Text>
          <p>
            <span>
              ㉾ 06665. 서울시 서초구 방배로 84 유성빌딩 3층 한양정보통신
              통신판매업신고 번호 : 제 2004-05089호
            </span>
          </p>
          <p>
            <span>
              대표전화번호 : 02-598-0050 FAX : 02-598-0906 대표:강경수 개인정보
              책임관리자:박기덕
            </span>
          </p>
          <p>
            <Copyright>
              ⓒ Hanyang Information & Communications Co., Ltd. All Rights
              Reserved.
            </Copyright>
          </p>
        </Text>
        <Combo onChange={selectChange}>
          <option value="title" defaultValue>
            Hanyang Family Site
          </option>
          <option value="hanyang">(주) 한양정보통신</option>
          <option value="gothic">HYGothic A1/B1/C1</option>
          <option value="fontbada">폰트바다</option>
        </Combo>
        <Icons>
          <Icon
            onClick={goToSNS}
            id="https://www.facebook.com/FONTBADA"
            icon={facebookicon}
          />
          <Icon
            onClick={goToSNS}
            id="https://blog.naver.com/hyfont"
            icon={blogicon}
          />
          <Icon
            onClick={goToSNS}
            id="https://pf.kakao.com/_xlxiJmxl"
            icon={kakaoicon}
          />
        </Icons>
      </Container>
    </Footers>
  );
};

export default Footer;
